/**
 * Files chosen before their destination (home page drop zone, sidebar Upload button) are parked
 * here in memory until the record page mounts and hands them to that folder's upload queue.
 * Nothing is persisted: a reload simply drops the files, which is the safe default.
 */
export interface PendingUpload {
  folderId: string;
  files: File[];
}

let pending: PendingUpload | null = null;

export function stashPendingUpload(folderId: string, files: File[]): void {
  pending = files.length > 0 ? { folderId, files } : null;
}

/** Returns and clears the files parked for `folderId`, or null. */
export function takePendingUpload(folderId: string): File[] | null {
  if (!pending || pending.folderId !== folderId) return null;
  const files = pending.files;
  pending = null;
  return files;
}

export function peekPendingUpload(): PendingUpload | null {
  return pending;
}
